import React, { FC } from "react";
import type { AutomationClickForKyccProps } from "@/types";
import { Cta } from "../cta";
import { Image } from "../image";
import { TextCols } from "../text-cols";

export const AutomationClickForKycc: FC<AutomationClickForKyccProps> = ({
  content,
  cta,
  cover,
}) => {
  return (
    <section className="automationClickForKycc">
      <div className="wrapper">
        <TextCols content={content} maxTitleWidth={766} />
      </div>
      <div className="wrapper wrapper_lg">
        {/* TODO: Temporary hidden */}
        {/* <Cta cta={cta} theme="light" className="automationClickForKycc--cta" /> */}
        {cover?.file?.url && (
          <Image
            src={cover as any}
            alt={cover.title}
            className="automationClickForKycc--cover"
          />
        )}
      </div>
    </section>
  );
};
